(() => {
  const root = document.querySelector("[data-ppf]");
  if (!root) return;
  const OPT = JSON.parse(document.getElementById("ppf-options").textContent);
  const endpoint = root.dataset.endpoint.replace(/\/$/, "");
  const form = root.querySelector("form");
  const status = root.querySelector(".ppf__status");
  const submitBtn = root.querySelector(".ppf__submit");
  const startedAt = Date.now();
  const submissionId = crypto.randomUUID ? crypto.randomUUID() : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
  const eventId = crypto.randomUUID ? crypto.randomUUID() : String(Date.now());
  const uploads = [];
  let wantsSubmit = false;
  let sending = false;

  const el = (tag, attrs = {}, kids = []) => {
    const n = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
      if (k === "text") n.textContent = v;
      else if (v !== false && v != null) n.setAttribute(k, v === true ? "" : v);
    }
    for (const k of [].concat(kids)) if (k) n.append(k);
    return n;
  };
  const cap = (s) => s.charAt(0) + s.slice(1).toLowerCase();

  root.querySelectorAll("select[data-options]").forEach((sel) => {
    for (const o of OPT[sel.dataset.options]) sel.append(el("option", { value: typeof o === "string" ? o : o.value, text: typeof o === "string" ? o : o.label }));
  });

  const chip = (type, name, value, label) => el("label", { class: "ppf__chip" }, [el("input", { type, name, value }), el("span", { text: label || value })]);
  root.querySelectorAll("[data-radios]").forEach((box) => OPT[box.dataset.radios].forEach((v) => box.append(chip("radio", box.dataset.radios, v))));
  root.querySelectorAll("[data-checks]").forEach((box) => OPT[box.dataset.checks].forEach((v) => box.append(chip("checkbox", box.dataset.checks, v, cap(v)))));

  const productsWrap = root.querySelector("[data-products]");
  const groups = {};
  for (const [sport, items] of Object.entries(OPT.products)) {
    const chips = el("div", { class: "ppf__chips" });
    items.forEach((v) => chips.append(chip("checkbox", `products.${sport}`, v)));
    groups[sport] = el("div", { class: "ppf__products", "data-sport": sport }, [el("p", { class: "ppf__sport", text: cap(sport) }), chips]);
    productsWrap.append(groups[sport]);
  }
  const syncProducts = () => {
    const picked = [...form.querySelectorAll('input[name="disciplines"]:checked')].map((i) => i.value).filter((v) => groups[v]);
    for (const [sport, g] of Object.entries(groups)) g.hidden = picked.length ? !picked.includes(sport) : false;
  };
  form.addEventListener("change", (e) => {
    if (e.target.name === "disciplines") syncProducts();
    clearError(e.target.closest(".ppf__field"));
  });
  syncProducts();

  const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
  const extOk = (name) => OPT.fileExt.includes((name.split(".").pop() || "").toLowerCase());

  root.querySelectorAll(".ppf__upload").forEach((zone) => {
    const box = zone.dataset.box;
    const input = el("input", { type: "file", multiple: true, class: "ppf__file", accept: OPT.fileExt.map((x) => `.${x}`).join(",") });
    const drop = el("button", { type: "button", class: "ppf__drop" }, [el("span", { class: "ppf__drop-main", text: "Add files" }), el("span", { class: "ppf__drop-sub", text: "or drag them here" })]);
    const list = el("ul", { class: "ppf__files" });
    zone.append(drop, input, list);
    drop.addEventListener("click", () => input.click());
    input.addEventListener("change", () => {
      addFiles(box, list, input.files);
      input.value = "";
    });
    zone.addEventListener("dragover", (e) => {
      e.preventDefault();
      zone.classList.add("is-over");
    });
    zone.addEventListener("dragleave", () => zone.classList.remove("is-over"));
    zone.addEventListener("drop", (e) => {
      e.preventDefault();
      zone.classList.remove("is-over");
      addFiles(box, list, e.dataTransfer.files);
    });
  });

  function addFiles(box, list, files) {
    for (const file of files) {
      if (uploads.filter((u) => u.state !== "removed").length >= OPT.maxFiles) {
        setStatus(`You can add up to ${OPT.maxFiles} files. Email anything else to your rep after you submit.`, true);
        break;
      }
      const u = { box, file, state: "uploading", id: null, xhr: null };
      const bar = el("span", { class: "ppf__bar" });
      const meta = el("span", { class: "ppf__meta", text: `${fmtSize(file.size)} · uploading 0%` });
      const remove = el("button", { type: "button", class: "ppf__remove", "aria-label": `Remove ${file.name}`, text: "Remove" });
      const row = el("li", { class: "ppf__item" }, [el("span", { class: "ppf__name", text: file.name }), meta, remove, el("span", { class: "ppf__track" }, bar)]);
      u.row = row;
      u.meta = meta;
      u.bar = bar;
      list.append(row);
      uploads.push(u);
      remove.addEventListener("click", () => {
        if (u.xhr) u.xhr.abort();
        u.state = "removed";
        row.remove();
        afterUploadChange();
      });
      if (!extOk(file.name)) fail(u, "This file type isn't supported. Try PDF, AI, EPS, PNG or JPG.");
      else if (file.size > OPT.maxFileBytes) fail(u, `Too large. Max ${fmtSize(OPT.maxFileBytes)} per file.`);
      else if (!file.size) fail(u, "This file is empty.");
      else send(u);
    }
    afterUploadChange();
  }

  function fail(u, msg) {
    u.state = "failed";
    u.row.classList.add("is-failed");
    u.meta.textContent = msg;
    afterUploadChange();
  }

  function send(u, attempt = 0) {
    const xhr = new XMLHttpRequest();
    u.xhr = xhr;
    xhr.open("POST", `${endpoint}/upload`);
    xhr.setRequestHeader("Content-Type", u.file.type || "application/octet-stream");
    xhr.setRequestHeader("X-File-Name", encodeURIComponent(u.file.name));
    xhr.upload.onprogress = (e) => {
      if (!e.lengthComputable) return;
      const pct = Math.min(99, Math.round((e.loaded / e.total) * 100));
      u.bar.style.width = `${pct}%`;
      u.meta.textContent = `${fmtSize(u.file.size)} · uploading ${pct}%`;
    };
    xhr.onload = () => {
      let r = {};
      try {
        r = JSON.parse(xhr.responseText);
      } catch {}
      if (xhr.status === 200 && r.ok) {
        u.id = r.id;
        u.state = "done";
        u.bar.style.width = "100%";
        u.row.classList.add("is-done");
        u.meta.textContent = `${fmtSize(u.file.size)} · uploaded`;
        afterUploadChange();
      } else if (r.error === "file_type") fail(u, "This file type isn't supported.");
      else if (r.error === "too_large") fail(u, "Too large to upload.");
      else retry(u, attempt);
    };
    xhr.onerror = () => retry(u, attempt);
    xhr.send(u.file);
  }

  function retry(u, attempt) {
    if (u.state === "removed") return;
    if (attempt < 2) {
      u.meta.textContent = `${fmtSize(u.file.size)} · connection dropped, retrying…`;
      setTimeout(() => send(u, attempt + 1), 1500 * (attempt + 1));
    } else fail(u, "Upload failed. Remove it and try again, or email it to your rep later.");
  }

  const pending = () => uploads.filter((u) => u.state === "uploading");

  function afterUploadChange() {
    const n = pending().length;
    if (wantsSubmit && !n) doSubmit();
    else if (wantsSubmit) setStatus(`Finishing ${n} upload${n > 1 ? "s" : ""}. Your form will send automatically when ${n > 1 ? "they're" : "it's"} done.`);
  }

  function setStatus(msg, isError) {
    status.textContent = msg || "";
    status.classList.toggle("is-error", !!isError);
  }

  function showError(field, msg) {
    if (!field) return;
    field.classList.add("has-error");
    let m = field.querySelector(".ppf__error");
    if (!m) field.append((m = el("span", { class: "ppf__error" })));
    m.textContent = msg;
  }
  function clearError(field) {
    if (!field) return;
    field.classList.remove("has-error");
    field.querySelector(".ppf__error")?.remove();
  }

  const val = (name) => (form.elements[name]?.value || "").trim();
  const checked = (name) => [...form.querySelectorAll(`input[name="${name}"]:checked`)].map((i) => i.value);

  function collect() {
    const products = {};
    for (const sport of Object.keys(OPT.products)) {
      const p = checked(`products.${sport}`);
      if (p.length && !groups[sport].hidden) products[sport] = p;
    }
    return {
      firstName: val("firstName"),
      lastName: val("lastName"),
      email: val("email"),
      phone: val("phone"),
      state: val("state"),
      teamName: val("teamName"),
      socialHandles: val("socialHandles"),
      rep: val("rep"),
      teamSize: checked("teamSize")[0] || "",
      disciplines: checked("disciplines"),
      products,
      pantone: val("pantone"),
      anythingElse: val("anythingElse"),
      heardFrom: checked("heardFrom")[0] || "",
    };
  }

  const LABEL_FIELD = { products: '[data-group="products"]', teamSize: '[data-group="teamSize"]', heardFrom: '[data-group="heardFrom"]' };
  const fieldFor = (name) => (LABEL_FIELD[name] ? root.querySelector(LABEL_FIELD[name]) : form.elements[name]?.closest(".ppf__field"));

  function checkLocal(f) {
    const errs = {};
    for (const k of ["firstName", "lastName", "teamName"]) if (!f[k]) errs[k] = "Required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email)) errs.email = "Enter a valid email";
    if (f.phone.replace(/\D/g, "").length < 10) errs.phone = "Enter a valid phone number";
    if (!f.state) errs.state = "Pick your state";
    if (!f.rep) errs.rep = "Pick your Pedal contact, or No contact yet";
    if (!f.teamSize) errs.teamSize = "Pick your team size";
    if (!Object.keys(f.products).length) errs.products = "Pick at least one product";
    if (!f.heardFrom) errs.heardFrom = "Let us know how you found us";
    return errs;
  }

  function showErrors(errs) {
    root.querySelectorAll(".has-error").forEach(clearError);
    let first = null;
    for (const [k, msg] of Object.entries(errs)) {
      const f = fieldFor(k);
      showError(f, msg);
      first = first || f;
    }
    if (first) first.scrollIntoView({ behavior: "smooth", block: "center" });
    return !!first;
  }

  function cookie(name) {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : "";
  }
  function attribution() {
    const gcl = (c) => (cookie(c).split(".").slice(2).join(".") || "");
    const ga = cookie("_ga").split(".").slice(2).join(".");
    return {
      url: location.href,
      referrer: document.referrer,
      gclid: new URLSearchParams(location.search).get("gclid") || gcl("_gcl_aw"),
      gbraid: new URLSearchParams(location.search).get("gbraid") || gcl("_gcl_gb"),
      fbc: cookie("_fbc"),
      fbp: cookie("_fbp"),
      gaClientId: ga,
      eventId,
    };
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (sending) return;
    const f = collect();
    if (showErrors(checkLocal(f))) {
      setStatus("Please fix the highlighted fields.", true);
      return;
    }
    wantsSubmit = true;
    submitBtn.disabled = true;
    submitBtn.classList.add("is-busy");
    if (pending().length) afterUploadChange();
    else doSubmit();
  });

  async function doSubmit() {
    if (sending) return;
    sending = true;
    wantsSubmit = false;
    setStatus("Sending your project…");
    const files = uploads.filter((u) => u.state === "done").map((u) => ({ id: u.id, box: u.box }));
    const body = { submissionId, startedAt, leave_empty: val("leave_empty"), fields: collect(), files, attribution: attribution() };
    let r = {};
    for (let attempt = 0; attempt < 3; attempt++) {
      body.turnstile = await freshToken();
      try {
        const res = await fetch(`${endpoint}/submit`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
        r = await res.json().catch(() => ({}));
        if (res.ok || (res.status < 500 && r.error !== "captcha")) break;
      } catch {
        r = { error: "network" };
      }
      await new Promise((ok) => setTimeout(ok, 1500 * (attempt + 1)));
    }
    if (r.ok) {
      (window.dataLayer = window.dataLayer || []).push({ event: "custom_order_form_submit", event_id: eventId, form_name: "custom order form", team_size: body.fields.teamSize });
      setStatus("Thanks! Taking you to book your design session…");
      location.href = r.redirect;
      return;
    }
    sending = false;
    submitBtn.disabled = false;
    submitBtn.classList.remove("is-busy");
    if (r.error === "invalid" && r.fields) {
      showErrors(r.fields);
      setStatus("Please fix the highlighted fields.", true);
    } else if (r.error === "rate_limited") setStatus("Too many attempts. Please wait a few minutes and try again, or call 888-308-0005.", true);
    else setStatus("Something went wrong sending the form. Please try again, or call us at 888-308-0005.", true);
  }

  const sitekey = root.dataset.turnstile;
  let widgetId = null;
  let tokenWaiter = null;
  if (sitekey) {
    window.ppfTurnstileReady = () => {
      widgetId = window.turnstile.render(root.querySelector("[data-turnstile-slot]"), {
        sitekey,
        execution: "execute",
        callback: (t) => tokenWaiter && tokenWaiter(t),
        "error-callback": () => tokenWaiter && tokenWaiter(""),
      });
    };
    document.head.append(el("script", { src: "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=ppfTurnstileReady&render=explicit", async: true, defer: true }));
  }

  function freshToken() {
    if (!sitekey || !window.turnstile || widgetId === null) return Promise.resolve("");
    return new Promise((resolve) => {
      const timer = setTimeout(() => resolve(""), 20000);
      tokenWaiter = (t) => {
        clearTimeout(timer);
        tokenWaiter = null;
        resolve(t);
      };
      window.turnstile.reset(widgetId);
      window.turnstile.execute(widgetId);
    });
  }
})();
